export function mountFooterAccordion(root = document) {
	const footer = root.querySelector(".solufy-footer");
	if (!footer) return () => {};

	const toggles = [...footer.querySelectorAll("[data-footer-toggle]")];
	const mobile = () => window.matchMedia("(max-width: 680px)").matches;

	const sync = () => {
		toggles.forEach((toggle) => {
			const panel = footer.querySelector(`#${toggle.getAttribute("aria-controls")}`);
			if (!panel) return;
			const expanded = toggle.getAttribute("aria-expanded") === "true";
			panel.classList.toggle("is-collapsed", mobile() && !expanded);
		});
	};

	const onClick = (event) => {
		if (!mobile()) return;
		const toggle = event.currentTarget;
		toggle.setAttribute("aria-expanded", toggle.getAttribute("aria-expanded") !== "true" ? "true" : "false");
		sync();
	};

	toggles.forEach((toggle) => toggle.addEventListener("click", onClick));
	window.addEventListener("resize", sync, { passive: true });
	sync();

	return () => {
		toggles.forEach((toggle) => toggle.removeEventListener("click", onClick));
		window.removeEventListener("resize", sync);
	};
}
